// This function gets and returns a list of active
// countries in countries.json
export const getAllActiveCountries = () => {
  const countries = require("../data/countries.json")
  let activeCountries = []

  countries.forEach(country => {
    // If the country is active
    if (country.active === "true") {
      // Add the country object to the list of countries
      activeCountries.push(country)
    }
  })

  // Return the newly generated array of countries
  return activeCountries
}
